export default class InputTool
{
  constructor(id, tool, photo) 
  {
    this.id = id;
    this.tool = tool;
    this.photo = photo;
  }    
}